


export const APP_NAME = 'MyReactApp';
//export const Media_Per_Page  : number = 0;
export const IsDevMode : number = 0; // 1 for dev mode, 0 for production
//export const SITE_KEY = "6Le-2QgsAAAAAL8nMtiLpqLY4ry1NZ73vEQsCf_z";  // dev serve
//export const SITE_KEY = "6LfkByIsAAAAAIgB3BAz2MkYUFJAlP74NzP0d0H9";  // Domain uat Client
// export const SITE_KEY = "6Lem2ggsAAAAADxKOlOtkHSqlcyyLgT7M-E-gQj2";   // localhost
// export const SITE_KEY = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";

// Base URL for the API-it is for dev environment

// export const CMS_API_BASE = 'https://grocms.hgsinteractive.com';
// export const CUS_API_BASE = 'https://groapi.hgsinteractive.com';
// export const frontUrl = 'https://grodev.hgsinteractive.com/';
// export const ImagePath = 'https://grocms.hgsinteractive.com/sites/default/files/';
// export const ImagePathurl = 'https://grocms.hgsinteractive.com/';



//client api it is for UAT environment

// export const ImagePath = 'https://cmsapi.letsgro.co/sites/default/files/';
// export const ImagePathurl = 'https://cmsapi.letsgro.co/';
// export const CMS_API_BASE = 'https://cmsapi.letsgro.co';   // Drupal Api 
// export const CUS_API_BASE = 'https://api-uat.letsgro.co'; //Custom Api Create here api chnge now on 28/11/25 instead of letsgro uat
// export const frontUrl = 'https://uat.letsgro.co/';

//client api it is for Production Live environment

export const ImagePath = 'https://livecms.letsgro.co/sites/default/files/';
export const ImagePathurl = 'https://livecms.letsgro.co/';
export const CMS_API_BASE = 'https://livecms.letsgro.co';   // Drupal Api 
export const CUS_API_BASE = 'https://liveapi.letsgro.co'; //Custom Api Create here api chnge now on 28/11/25 instead of letsgro uat
export const frontUrl = "https://www.letsgro.co/";

// export const frontUrl = 'https://letsgro.co/';
